import _slicedToArray from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime@7.14.6/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import moment from 'moment-timezone';
import { getSpecialHoursDays, openInfoForDispensary } from 'shared/core/helpers/dispensaries';
import { dayIdToDayOfWeek, daysOfWeek } from 'shared/constants';
import { createTimeSlot, stripNextDaySuffix, hasNextDaySuffix } from 'shared/helpers/time-utils';
function daysDefault() {
  return {
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: []
  };
}

// Takes slot data coming back from the reservation_slots table and organizes it into maxReservationSlotsByDay and
// maxReservationSlotsByDate for each orderType
export var formatAndOrganizeSlots = function formatAndOrganizeSlots(_ref) {
  var slots = _ref.slots,
    includeCurrentCount = _ref.includeCurrentCount,
    includeDayOfWeek = _ref.includeDayOfWeek,
    includeSlotId = _ref.includeSlotId,
    timezone = _ref.timezone;
  var orderTypeSlots = {
    curbsidePickup: {
      maxReservationSlotsByDay: daysDefault(),
      maxReservationSlotsByDate: []
    },
    delivery: {
      maxReservationSlotsByDay: daysDefault(),
      maxReservationSlotsByDate: []
    },
    driveThruPickup: {
      maxReservationSlotsByDay: daysDefault(),
      maxReservationSlotsByDate: []
    },
    inStorePickup: {
      maxReservationSlotsByDay: daysDefault(),
      maxReservationSlotsByDate: []
    }
  };
  var sortedSlots = _.sortBy(slots, ['reservation_type', 'day_of_week', 'start_at']);
  _.forEach(sortedSlots, function (slot) {
    // if bad order/reservation type is present, ignore
    if (!Object.keys(orderTypeSlots).includes(slot.reservation_type)) {
      return;
    }
    var effectiveDayOfWeek = dayIdToDayOfWeek[slot.day_of_week];
    var orderTypeSlotsConfig = orderTypeSlots[slot.reservation_type];

    // Use the pre-stored flag instead of complex calculation
    var isNextDaySlot = slot.is_next_day_slot;
    var startTime = moment.tz(slot.start_at, 'HH:mm', timezone);
    var formattedSlot = _objectSpread(_objectSpread(_objectSpread({
      startTime: slot.start_at,
      endTime: startTime.add(slot.duration, 'minutes').format('HH:mm'),
      maxOrders: slot.max_orders,
      deliveryAreaId: slot.delivery_area_id,
      active: slot.active,
      isNextDaySlot: isNextDaySlot
    }, includeCurrentCount && {
      currentCount: slot.current_count
    }), includeDayOfWeek && {
      dayOfWeek: effectiveDayOfWeek
    }), includeSlotId && {
      slotId: slot.id
    });
    if (!slot.valid_to) {
      orderTypeSlotsConfig.maxReservationSlotsByDay[effectiveDayOfWeek].push(formattedSlot);
    } else {
      orderTypeSlotsConfig.maxReservationSlotsByDate.push(_objectSpread(_objectSpread({}, formattedSlot), {}, {
        date: moment(slot.valid_to).tz(timezone).format('YYYY-MM-DD')
      }, includeDayOfWeek && {
        dayOfWeek: effectiveDayOfWeek
      }));
    }
  });
  return orderTypeSlots;
};

// Filters date-specific slots to the lookahead window and returns two maps in a single pass:
//   mergedByDayOfWeek — standard day-of-week slots with date-specific overrides merged on top
//   slotOverridesByDate — date-keyed map for exact-date lookups (prevents cross-week contamination)
var mergeOrderTypeSlots = function mergeOrderTypeSlots(orderTypeSlots, timezone) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$dayLimit = _ref2.dayLimit,
    dayLimit = _ref2$dayLimit === void 0 ? 6 : _ref2$dayLimit;
  var today = moment.tz(timezone).startOf('day');
  var windowEnd = moment.tz(timezone).add(dayLimit, 'days').endOf('day');
  var specialSlotsForDaysOfWeek = {};
  var slotOverridesByDate = {};
  _.forEach(orderTypeSlots.maxReservationSlotsByDate, function (slot) {
    if (!slot.date || !moment.tz(slot.date, timezone).isBetween(today, windowEnd, undefined, '[]')) {
      return;
    }
    if (!specialSlotsForDaysOfWeek[slot.dayOfWeek]) {
      specialSlotsForDaysOfWeek[slot.dayOfWeek] = [];
    }
    specialSlotsForDaysOfWeek[slot.dayOfWeek].push(slot);
    if (!slotOverridesByDate[slot.date]) {
      slotOverridesByDate[slot.date] = [];
    }
    slotOverridesByDate[slot.date].push(slot);
  });
  var mergedByDayOfWeek = _objectSpread(_objectSpread({}, orderTypeSlots.maxReservationSlotsByDay), specialSlotsForDaysOfWeek);
  return {
    mergedByDayOfWeek: mergedByDayOfWeek,
    slotOverridesByDate: slotOverridesByDate
  };
};

// Builds the list of available days (with closure status) for the advanced day ordering window.
export var getAdvancedDayOrderingAvailableDays = function getAdvancedDayOrderingAvailableDays(today, dayLimit, effectiveHoursForOrderType, specialHoursByDate) {
  var availableDays = [];
  for (var i = 0; i <= dayLimit; i++) {
    var _effectiveHoursForOrd;
    var currentDay = moment(today).add(i, 'day');
    var dayOfWeek = currentDay.format('dddd');

    // Check date-specific special hours first (handles closures beyond the current week),
    // then fall back to the day-of-week effectiveHours which only covers the current week.
    var dateOverride = specialHoursByDate === null || specialHoursByDate === void 0 ? void 0 : specialHoursByDate[currentDay.format('YYYY-MM-DD')];
    var isClosed = dateOverride !== undefined ? dateOverride.active === false : ((_effectiveHoursForOrd = effectiveHoursForOrderType[dayOfWeek]) === null || _effectiveHoursForOrd === void 0 ? void 0 : _effectiveHoursForOrd.active) === false;
    availableDays.push({
      date: currentDay.format('MM/DD/YYYY'),
      dayOfWeek: dayOfWeek,
      isClosed: isClosed
    });
  }
  return availableDays;
};

// Gets available slot reservations based on formatted data from free_reservation route
export var getCurrentSlotsForOrderType = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(orderType, dispensary, orderTypeSlots) {
    var _scheduledOrderingCon, _openInfo$orderType, _scheduledOrderingCon4;
    var _ref4,
      _ref4$extendedDayOrde,
      extendedDayOrdering,
      timezone,
      _dispensary$hoursSett,
      baseHours,
      effectiveHours,
      specialHours,
      _dispensary$orderType,
      enableAfterHoursOrdering,
      scheduledOrderingConfigV2,
      openInfo,
      nextOpenMoment,
      today,
      nextOpenDay,
      todayDate,
      todayDayOfWeek,
      nextOpenDate,
      nextOpenDayOfWeek,
      nextAvailableBuffer,
      nextAvailableTime,
      availableDays,
      _scheduledOrderingCon3,
      specialHoursByDate,
      _scheduledOrderingCon2,
      advancedLimit,
      windowEnd,
      specialHoursDays,
      fallbackHours,
      dayLimit,
      _mergeOrderTypeSlots,
      mergedOrderTypeSlots,
      slotOverridesByDate,
      notDeliveryOrder,
      hasDateOverrides,
      availableSlots,
      sortedSlots,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref4 = _args.length > 3 && _args[3] !== undefined ? _args[3] : {}, _ref4$extendedDayOrde = _ref4.extendedDayOrdering, extendedDayOrdering = _ref4$extendedDayOrde === void 0 ? false : _ref4$extendedDayOrde;
          timezone = dispensary.timezone;
          _dispensary$hoursSett = dispensary.hoursSettings[orderType], baseHours = _dispensary$hoursSett.hours, effectiveHours = _dispensary$hoursSett.effectiveHours, specialHours = _dispensary$hoursSett.specialHours;
          _dispensary$orderType = dispensary.orderTypesConfigV2[orderType], enableAfterHoursOrdering = _dispensary$orderType.enableAfterHoursOrdering, scheduledOrderingConfigV2 = _dispensary$orderType.scheduledOrderingConfigV2;
          openInfo = openInfoForDispensary(dispensary, {});
          nextOpenMoment = _.get(openInfo, "".concat(orderType, ".nextService.openMoment"));
          if (nextOpenMoment) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", []);
        case 8:
          // No open hours for this orderType
          today = moment.tz(timezone).startOf('day');
          nextOpenDay = nextOpenMoment.tz(timezone);
          todayDate = today.format('MM/DD/YYYY');
          todayDayOfWeek = today.format('dddd');
          nextOpenDate = nextOpenDay.format('MM/DD/YYYY');
          nextOpenDayOfWeek = nextOpenDay.format('dddd');
          nextAvailableBuffer = (_scheduledOrderingCon = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.nextAvailableInMinutes) !== null && _scheduledOrderingCon !== void 0 ? _scheduledOrderingCon : 10;
          nextAvailableTime = moment.tz(timezone).add(nextAvailableBuffer, 'minutes');
          availableDays = [];
          if (scheduledOrderingConfigV2 !== null && scheduledOrderingConfigV2 !== void 0 && scheduledOrderingConfigV2.advancedDayOrderingEnabled) {
            if (extendedDayOrdering && specialHours) {
              advancedLimit = (_scheduledOrderingCon2 = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.advancedDayOrderingLimit) !== null && _scheduledOrderingCon2 !== void 0 ? _scheduledOrderingCon2 : 1;
              windowEnd = moment.tz(timezone).add(advancedLimit, 'days').endOf('day');
              specialHoursDays = getSpecialHoursDays(specialHours, timezone);
              specialHoursByDate = {};
              specialHoursDays.forEach(function (_ref5) {
                var date = _ref5.date,
                  hours = _ref5.hours;
                if (moment.tz(date, timezone).isBetween(today, windowEnd, undefined, '[]')) {
                  specialHoursByDate[moment.tz(date, timezone).format('YYYY-MM-DD')] = hours;
                }
              });
            }

            // When specialHoursByDate is populated (extended ordering), use baseHours as fallback
            // so that a closure on *this* week's Monday (reflected in effectiveHours) doesn't
            // bleed into future Mondays that have no date-specific override.
            fallbackHours = specialHoursByDate ? baseHours : effectiveHours;
            availableDays = getAdvancedDayOrderingAvailableDays(today, (_scheduledOrderingCon3 = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.advancedDayOrderingLimit) !== null && _scheduledOrderingCon3 !== void 0 ? _scheduledOrderingCon3 : 1, fallbackHours, specialHoursByDate);
          } else if (!((_openInfo$orderType = openInfo[orderType]) !== null && _openInfo$orderType !== void 0 && _openInfo$orderType.isClosed)) {
            availableDays.push({
              date: todayDate,
              dayOfWeek: todayDayOfWeek
            });
          } else if (enableAfterHoursOrdering) {
            availableDays.push({
              date: nextOpenDate,
              dayOfWeek: nextOpenDayOfWeek
            });
          }
          dayLimit = (_scheduledOrderingCon4 = scheduledOrderingConfigV2 === null || scheduledOrderingConfigV2 === void 0 ? void 0 : scheduledOrderingConfigV2.advancedDayOrderingLimit) !== null && _scheduledOrderingCon4 !== void 0 ? _scheduledOrderingCon4 : 6;
          _mergeOrderTypeSlots = mergeOrderTypeSlots(orderTypeSlots, timezone, {
            dayLimit: dayLimit
          }), mergedOrderTypeSlots = _mergeOrderTypeSlots.mergedByDayOfWeek, slotOverridesByDate = _mergeOrderTypeSlots.slotOverridesByDate;
          notDeliveryOrder = orderType !== 'delivery';
          hasDateOverrides = Object.keys(slotOverridesByDate).length > 0;
          availableSlots = _.reduce(availableDays, function (totalSlots, _ref6) {
            var _orderTypeSlots$maxRe;
            var date = _ref6.date,
              dayOfWeek = _ref6.dayOfWeek,
              isClosed = _ref6.isClosed;
            if (isClosed) {
              return totalSlots;
            }

            // Prefer date-specific slots when they exist, otherwise use the day-of-week slots.
            // When date overrides exist but not for this date, fall back to standard (unmerged) day-of-week
            // slots to prevent one Monday's special hours from leaking into a different Monday.
            var normalizedDate = moment.tz(date, 'MM/DD/YYYY', timezone).format('YYYY-MM-DD');
            var effectiveSlots = hasDateOverrides && slotOverridesByDate[normalizedDate] || (hasDateOverrides ? (_orderTypeSlots$maxRe = orderTypeSlots.maxReservationSlotsByDay) === null || _orderTypeSlots$maxRe === void 0 ? void 0 : _orderTypeSlots$maxRe[dayOfWeek] : mergedOrderTypeSlots === null || mergedOrderTypeSlots === void 0 ? void 0 : mergedOrderTypeSlots[dayOfWeek]);
            var slotsPerDay = _.reduce(effectiveSlots, function (slots, slot) {
              // If it's a "next day" slot, we need to adjust the date to the next day so that the time is technically correct
              var slotDate = slot.isNextDaySlot ? moment(date, 'MM/DD/YYYY').add(1, 'day').format('MM/DD/YYYY') : date;
              var _createTimeSlot = createTimeSlot(slot.startTime, slot.endTime, slotDate, timezone),
                startTimeISO = _createTimeSlot.startTimeISO,
                endTimeISO = _createTimeSlot.endTimeISO;
              var startTime = moment(startTimeISO);
              var quantityRemaining = 500;
              if (slot.deliveryAreaId || scheduledOrderingConfigV2 !== null && scheduledOrderingConfigV2 !== void 0 && scheduledOrderingConfigV2.orderLimitsEnabled) {
                quantityRemaining = slot.maxOrders - slot.currentCount;
              }

              // Skip slots with no capacity
              if (slot.maxOrders === 0) {
                return slots;
              }
              if (notDeliveryOrder) {
                // Skip slots where nextAvailableTime is after the slot ends (slot is too early)
                if (nextAvailableTime.isAfter(endTimeISO)) {
                  return slots;
                }
              } else if (startTime.isBefore(nextAvailableTime)) {
                // Skip delivery slots that start before nextAvailableTime
                return slots;
              }

              /*
               * NOTE: currently preventing a quantityRemaining value under 0, even if an admin adjusts the maxOrder value
               * on a timeslot below the currently reserved orders within that timeslot. This could easily be removed if
               * having that information is needed later (in an error warning while updating settings, for example)
               */
              slots.push(_objectSpread({
                slotId: slot.slotId,
                deliveryAreaId: slot.deliveryAreaId,
                active: slot.active,
                startTimeISO: startTimeISO,
                endTimeISO: endTimeISO,
                quantityRemaining: quantityRemaining < 0 ? 0 : quantityRemaining,
                isNextDaySlot: slot.isNextDaySlot
              }, slot.dayOfWeek && {
                dayOfWeek: slot.dayOfWeek
              }));
              return slots;
            }, []);
            return [].concat(_toConsumableArray(totalSlots), _toConsumableArray(slotsPerDay));
          }, []);
          sortedSlots = _.sortBy(availableSlots, 'startTimeISO');
          return _context.abrupt("return", sortedSlots);
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCurrentSlotsForOrderType(_x, _x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

// Fills in currentCount and maxOrders data for a slot based on previous reservationConfig data
var hydrateSlotData = function hydrateSlotData(reservationOptions, day, startTime, endTime, date) {
  var _reservationOptions$m;
  var slots = date ? reservationOptions === null || reservationOptions === void 0 ? void 0 : reservationOptions.maxReservationSlotsByDate : reservationOptions === null || reservationOptions === void 0 || (_reservationOptions$m = reservationOptions.maxReservationSlotsByDay) === null || _reservationOptions$m === void 0 ? void 0 : _reservationOptions$m[day];
  var getMaxOrders = function getMaxOrders(maxOrdersValue) {
    if (maxOrdersValue === undefined) {
      return 500;
    }
    if (maxOrdersValue === '') {
      return 0;
    }
    return maxOrdersValue;
  };
  if (!slots) {
    return {
      currentCount: 0,
      maxOrders: 500
    };
  }
  var predicate = date ? function (slot) {
    var slotDate = _.isString(slot.date) ? slot.date : moment.utc(slot.date).format('YYYY-MM-DD');
    return date === slotDate && startTime === slot.startTime && endTime === slot.endTime;
  } : function (slot) {
    return startTime === slot.startTime && endTime === slot.endTime;
  };
  var matchingSlot = _.find(slots, predicate);
  if (matchingSlot) {
    return {
      currentCount: (matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.currentCount) || 0,
      maxOrders: getMaxOrders(matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.maxOrders),
      slotId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.slotId
    };
  }
  return {
    currentCount: 0,
    maxOrders: 500
  };
};
var hydrateSlotDataV2 = function hydrateSlotDataV2(reservationOptions, day, startTime, endTime, date, reservationType, zone) {
  var _reservationOptions$m2;
  var isNextDaySlot = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var slots = date ? reservationOptions === null || reservationOptions === void 0 ? void 0 : reservationOptions.maxReservationSlotsByDate : reservationOptions === null || reservationOptions === void 0 || (_reservationOptions$m2 = reservationOptions.maxReservationSlotsByDay) === null || _reservationOptions$m2 === void 0 ? void 0 : _reservationOptions$m2[day];
  var getMaxOrders = function getMaxOrders(maxOrdersValue) {
    if (maxOrdersValue === undefined) {
      return 500;
    }
    if (maxOrdersValue === '') {
      return 0;
    }
    return maxOrdersValue;
  };
  if (!slots) {
    return {
      currentCount: 0,
      maxOrders: 500,
      deliveryAreaId: zone.name,
      active: true
    };
  }
  var predicate = date ? function (slot) {
    var _slot$isNextDaySlot;
    var slotDate = _.isString(slot.date) ? slot.date : moment.utc(slot.date).format('YYYY-MM-DD');
    return date === slotDate && startTime === slot.startTime && endTime === slot.endTime && zone.name === slot.deliveryAreaId && ((_slot$isNextDaySlot = slot.isNextDaySlot) !== null && _slot$isNextDaySlot !== void 0 ? _slot$isNextDaySlot : false) === isNextDaySlot;
  } : function (slot) {
    var _slot$isNextDaySlot2;
    return startTime === slot.startTime && endTime === slot.endTime && zone.name === slot.deliveryAreaId && ((_slot$isNextDaySlot2 = slot.isNextDaySlot) !== null && _slot$isNextDaySlot2 !== void 0 ? _slot$isNextDaySlot2 : false) === isNextDaySlot;
  };
  var matchingSlot = _.find(slots, predicate);
  if (matchingSlot) {
    return {
      currentCount: (matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.currentCount) || 0,
      maxOrders: getMaxOrders(matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.maxOrders),
      slotId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.slotId,
      deliveryAreaId: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.deliveryAreaId,
      active: matchingSlot === null || matchingSlot === void 0 ? void 0 : matchingSlot.active
    };
  }
  return {
    currentCount: 0,
    maxOrders: 500,
    deliveryAreaId: zone.name,
    active: true
  };
};

// Creates slots given a start time up to an end time spaced by increment, hydrating with previously stored maxOrders
var getTimeSlots = function getTimeSlots(reservationOptionsForOrderType, day, dayStartTimeString, dayEndTimeString, increment, date, reservationType, deliveryZones, deliveryMode) {
  // Handle Next Day suffix in time strings using utilities
  var actualDayStartTimeString = stripNextDaySuffix(dayStartTimeString);
  var actualDayEndTimeString = stripNextDaySuffix(dayEndTimeString);
  var isEndTimeNextDay = hasNextDaySuffix(dayEndTimeString);
  var dayStartTime = actualDayStartTimeString === 'open' ? moment('12:00 AM', 'h:mm A') : moment(actualDayStartTimeString, 'h:mm A');
  var dayEndTime = actualDayEndTimeString === 'open' || actualDayEndTimeString === '12:00 AM' ? moment('11:59:59 PM', 'h:mm:ss A') : moment(actualDayEndTimeString, 'h:mm A');

  // If end time is next day, we need to extend the end time comparison
  if (isEndTimeNextDay && actualDayEndTimeString !== 'open' && actualDayEndTimeString !== '12:00 AM') {
    dayEndTime.add(1, 'day');
  }
  var formattedDate = date ? moment.utc(date).format('YYYY-MM-DD') : undefined;

  // Track whether we've crossed midnight during slot generation
  var hasCrossedMidnight = false;

  /**
   * Determines if a slot is in the "next day" portion of extended hours
   * @param {moment.Moment} slotTime - The slot start time
   * @param {moment.Moment} previousSlotTime - The previous slot time (to detect midnight crossing)
   * @returns {boolean} - True if this slot is in the extended hours (next day) portion
   */
  var isSlotNextDay = function isSlotNextDay(slotTime, previousSlotTime) {
    // Only extended hours can have next-day slots
    if (!isEndTimeNextDay) {
      return false;
    }

    // Detect if we've crossed midnight by checking if current slot is earlier than previous
    if (previousSlotTime && slotTime.hour() < previousSlotTime.hour() && previousSlotTime.hour() >= 22) {
      hasCrossedMidnight = true;
    }

    // If we haven't crossed midnight yet, early morning slots are current day
    if (!hasCrossedMidnight) {
      return false;
    }

    // After crossing midnight, early morning slots (0-6 AM) are next day
    return slotTime.hour() >= 0 && slotTime.hour() <= 6;
  };
  var createSlots = function createSlots(slots, slotStartTime) {
    var previousSlotTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (slotStartTime.isSameOrAfter(dayEndTime)) {
      return slots;
    }
    var slotStartTimeString = slotStartTime.format('HH:mm');
    var slotEndTime = moment(slotStartTime).add(increment, 'm');
    var slotEndTimeString = slotEndTime.format('HH:mm');
    var slotEndTimeAdjusted = slotEndTimeString === '00:00' ? moment('23:59:59', 'HH:mm:ss') : slotEndTime;
    var lastSlotDisjointed = slotEndTimeAdjusted.isAfter(dayEndTime);
    if (lastSlotDisjointed) {
      slotEndTimeString = actualDayEndTimeString === 'open' || actualDayEndTimeString === '12:00 AM' ? '00:00' : dayEndTime.format('HH:mm');
    }

    // Determine if this slot is in the next day portion
    var isNextDaySlot = isSlotNextDay(slotStartTime, previousSlotTime);
    if (deliveryZones && deliveryZones.length > 0 && reservationType === 'delivery' && deliveryMode === 'drawn') {
      deliveryZones.forEach(function (zone) {
        var hydratedSlotData = hydrateSlotDataV2(reservationOptionsForOrderType, day, slotStartTimeString, slotEndTimeString, formattedDate, reservationType, _objectSpread({}, zone), isNextDaySlot);
        slots.push(_objectSpread(_objectSpread({}, formattedDate && {
          date: formattedDate
        }), {}, {
          startTime: slotStartTimeString,
          endTime: slotEndTimeString,
          maxOrders: hydratedSlotData.maxOrders,
          currentCount: hydratedSlotData.currentCount,
          slotId: hydratedSlotData.slotId,
          deliveryAreaId: hydratedSlotData.deliveryAreaId,
          active: hydratedSlotData.active,
          isNextDaySlot: isNextDaySlot // Store the next day determination
        }));
      });
      if (lastSlotDisjointed) {
        return slots;
      }
      return createSlots(slots, slotEndTime, slotStartTime);
    }
    var hydratedSlotData = hydrateSlotData(reservationOptionsForOrderType, day, slotStartTimeString, slotEndTimeString, formattedDate, reservationType);
    slots.push(_objectSpread(_objectSpread({}, formattedDate && {
      date: formattedDate
    }), {}, {
      startTime: slotStartTimeString,
      endTime: slotEndTimeString,
      maxOrders: hydratedSlotData.maxOrders,
      currentCount: hydratedSlotData.currentCount,
      slotId: hydratedSlotData.slotId,
      isNextDaySlot: isNextDaySlot // Store the next day determination
    }));
    if (lastSlotDisjointed) {
      return slots;
    }
    return createSlots(slots, slotEndTime, slotStartTime);
  };
  return createSlots([], dayStartTime);
};

// Generates all possible slots for a particular order type per day of the week based on an increment
var getOrderTypeSlotsByDay = function getOrderTypeSlotsByDay(isOrderTypeOffered, orderTypeHours, orderTypeSpecialHours, reservationOptionsForOrderType, reservationType, deliveryZones, deliveryMode) {
  var incrementInMinutes = (reservationOptionsForOrderType === null || reservationOptionsForOrderType === void 0 ? void 0 : reservationOptionsForOrderType.incrementInMinutes) || 30;
  var standardSlots = {};
  var specialSlots = {};
  _.forEach(daysOfWeek, function (day) {
    var dayValue = day.value;
    if (!orderTypeHours[dayValue] || !orderTypeHours[dayValue].active) {
      standardSlots[dayValue] = [];
    } else {
      standardSlots[dayValue] = getTimeSlots(reservationOptionsForOrderType, dayValue, orderTypeHours[dayValue].start, orderTypeHours[dayValue].end, incrementInMinutes, '', reservationType, deliveryZones, deliveryMode);
    }
    if (isOrderTypeOffered && orderTypeSpecialHours[dayValue]) {
      var entries = Array.isArray(orderTypeSpecialHours[dayValue]) ? orderTypeSpecialHours[dayValue] : [orderTypeSpecialHours[dayValue]];
      specialSlots[dayValue] = entries.flatMap(function (entry) {
        if (!entry.active) {
          return [];
        }
        return getTimeSlots(reservationOptionsForOrderType, dayValue, entry.start, entry.end, incrementInMinutes, entry.date, reservationType, deliveryZones, deliveryMode);
      });
    }
  });
  return {
    standard: standardSlots,
    special: specialSlots
  };
};

// Gets special hours within the configured lookahead window (defaults to 6 days for backwards compatibility).
// Returns arrays per day-of-week to support multiple instances of the same day (e.g., two Mondays in a 14-day window).
var getUpcomingSpecialHours = function getUpcomingSpecialHours(specialHours, timezone) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref7$dayLimit = _ref7.dayLimit,
    dayLimit = _ref7$dayLimit === void 0 ? 6 : _ref7$dayLimit;
  var specialHoursByDayOfWeek = {};
  if (!specialHours) {
    return specialHoursByDayOfWeek;
  }
  var specialHoursDays = getSpecialHoursDays(specialHours, timezone);
  var today = moment().tz(timezone).startOf('day');
  var windowEnd = moment(today).add(dayLimit, 'days').endOf('day');
  var upcomingSpecialHours = _.filter(specialHoursDays, function (_ref8) {
    var date = _ref8.date;
    var specialHoursDate = moment.tz(date, timezone);
    return specialHoursDate.isBetween(today, windowEnd, undefined, '[]');
  });
  _.forEach(upcomingSpecialHours, function (day) {
    var specialHoursDayOfWeek = moment.tz(day.date, timezone).format('dddd');
    if (!specialHoursByDayOfWeek[specialHoursDayOfWeek]) {
      specialHoursByDayOfWeek[specialHoursDayOfWeek] = [];
    }
    specialHoursByDayOfWeek[specialHoursDayOfWeek].push(_objectSpread(_objectSpread({}, day.hours), {}, {
      date: day.date
    }));
  });
  return specialHoursByDayOfWeek;
};

// Updated method to work with new ordering and hours settings by type
/**
 * @typedef {import('types/graphql').GqlWeeklyHours} GqlWeeklyHours
 * @typedef {import('types/graphql').GqlSpecialHours} GqlSpecialHours
 * @typedef {import('types/graphql').GqlReservationOptionsForOrderType} GqlReservationOptionsForOrderType
 *
 * @typedef {Object} SlotsByDay
 * @property {Object} standard
 * @property {Object} special
 *
 * @typedef {Object} ReservationSlotsPerOrderTypeArgs
 * @property {boolean} orderTypeEnabled
 * @property {GqlWeeklyHours} orderTypeHours
 * @property {GqlSpecialHours[]} orderTypeSpecialHours
 * @property {GqlReservationOptionsForOrderType} orderTypeReservationConfig
 * @property {string} timezone
 * @property {string} reservationType
 * @property {string} deliveryMode
 * @property {GqlDeliveryZones[]} deliveryZones
 *
 * @callback GetReservationSlotsPerOrderType
 * @param {ReservationSlotsPerOrderTypeArgs}
 * @returns {SlotsByDay}
 */

/** @type {GetReservationSlotsPerOrderType}  */
export function getReservationSlotsPerOrderType(_ref9) {
  var _orderTypeReservation;
  var _ref9$orderTypeEnable = _ref9.orderTypeEnabled,
    orderTypeEnabled = _ref9$orderTypeEnable === void 0 ? false : _ref9$orderTypeEnable,
    _ref9$orderTypeHours = _ref9.orderTypeHours,
    orderTypeHours = _ref9$orderTypeHours === void 0 ? {} : _ref9$orderTypeHours,
    _ref9$orderTypeSpecia = _ref9.orderTypeSpecialHours,
    orderTypeSpecialHours = _ref9$orderTypeSpecia === void 0 ? [] : _ref9$orderTypeSpecia,
    _ref9$orderTypeReserv = _ref9.orderTypeReservationConfig,
    orderTypeReservationConfig = _ref9$orderTypeReserv === void 0 ? {} : _ref9$orderTypeReserv,
    timezone = _ref9.timezone,
    _ref9$reservationType = _ref9.reservationType,
    reservationType = _ref9$reservationType === void 0 ? '' : _ref9$reservationType,
    _ref9$deliveryZones = _ref9.deliveryZones,
    deliveryZones = _ref9$deliveryZones === void 0 ? [] : _ref9$deliveryZones,
    _ref9$deliveryMode = _ref9.deliveryMode,
    deliveryMode = _ref9$deliveryMode === void 0 ? '' : _ref9$deliveryMode;
  var dayLimit = (_orderTypeReservation = orderTypeReservationConfig === null || orderTypeReservationConfig === void 0 ? void 0 : orderTypeReservationConfig.advancedDayOrderingLimit) !== null && _orderTypeReservation !== void 0 ? _orderTypeReservation : 6;
  var specialHoursWithinNextWeek = getUpcomingSpecialHours(orderTypeSpecialHours, timezone, {
    dayLimit: dayLimit
  });
  var slotsByDay = getOrderTypeSlotsByDay(orderTypeEnabled, orderTypeHours, specialHoursWithinNextWeek, orderTypeReservationConfig || {}, reservationType, deliveryZones, deliveryMode);
  return slotsByDay;
}
/** Finds the index in advancedDayOrderingDays that matches a reservation, using date when extended ordering is enabled to disambiguate duplicate day-of-week entries. */
export function findSelectedDayIndex(_ref0) {
  var advancedDayOrderingDays = _ref0.advancedDayOrderingDays,
    reservationOption = _ref0.reservationOption,
    _ref0$extendedDayOrde = _ref0.extendedDayOrdering,
    extendedDayOrdering = _ref0$extendedDayOrde === void 0 ? false : _ref0$extendedDayOrde,
    timezone = _ref0.timezone;
  if (extendedDayOrdering && reservationOption !== null && reservationOption !== void 0 && reservationOption.startTimeISO) {
    var reservationDate = moment.tz(reservationOption.startTimeISO, timezone).format('YYYY-MM-DD');
    return _.findIndex(advancedDayOrderingDays, ['date', reservationDate]);
  }
  return _.findIndex(advancedDayOrderingDays, ['dayOfWeek', reservationOption === null || reservationOption === void 0 ? void 0 : reservationOption.dayOfWeek]);
}
export function getAdvancedDayOrderingDays(_ref1) {
  var advancedDayOrderingLimit = _ref1.advancedDayOrderingLimit,
    timezone = _ref1.timezone,
    _ref1$extendedDayOrde = _ref1.extendedDayOrdering,
    extendedDayOrdering = _ref1$extendedDayOrde === void 0 ? false : _ref1$extendedDayOrde;
  var dayOptions = [];
  var getDayString = function getDayString(index, day) {
    var dayOfWeek = day.format('dddd');
    var labels = ['Today', 'Tomorrow'];
    // Include the date in labels when extended ordering is enabled to avoid ambiguity
    // when the window exceeds 7 days (e.g., two "Monday" entries become "Monday (3/16)" and "Monday (3/23)")
    var label;
    if (index < labels.length) {
      label = labels[index];
    } else if (extendedDayOrdering) {
      label = "".concat(dayOfWeek, " (").concat(day.format('M/D'), ")");
    } else {
      label = dayOfWeek;
    }
    return {
      day: day,
      dayOfWeek: dayOfWeek,
      date: day.format('YYYY-MM-DD'),
      label: label,
      value: index
    };
  };
  var limit = advancedDayOrderingLimit !== null && advancedDayOrderingLimit !== void 0 ? advancedDayOrderingLimit : 1;
  for (var i = 0; i <= limit; i++) {
    dayOptions.push(getDayString(i, moment.tz(timezone).add(i, 'day')));
  }
  return dayOptions;
}
export function sameDayDeliveryAdjustedOrderingDays(advancedDayOrderingLimit, timezone) {
  var extendedDayOrdering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = getAdvancedDayOrderingDays({
    advancedDayOrderingLimit: advancedDayOrderingLimit,
    timezone: timezone,
    extendedDayOrdering: extendedDayOrdering
  });
  options.shift();
  options.forEach(function (option) {
    option.value -= 1;
  });
  return options;
}
export function getAdvancedDayOrderingTimes(_ref10) {
  var _ref10$advancedDayOrd = _ref10.advancedDayOrderingDays,
    advancedDayOrderingDays = _ref10$advancedDayOrd === void 0 ? [] : _ref10$advancedDayOrd,
    _ref10$reservationOpt = _ref10.reservationOptions,
    reservationOptions = _ref10$reservationOpt === void 0 ? [] : _ref10$reservationOpt,
    _ref10$selectedDayInd = _ref10.selectedDayIndex,
    selectedDayIndex = _ref10$selectedDayInd === void 0 ? 0 : _ref10$selectedDayInd,
    _ref10$extendedDayOrd = _ref10.extendedDayOrdering,
    extendedDayOrdering = _ref10$extendedDayOrd === void 0 ? false : _ref10$extendedDayOrd,
    timezone = _ref10.timezone;
  var selectedDay = advancedDayOrderingDays[selectedDayIndex];
  if (!selectedDay) {
    return [];
  }

  // When advancedDayOrderingLimit > 7, the same day-of-week name appears multiple times (e.g., two "Monday" entries).
  // Filter by exact date instead of dayOfWeek to avoid conflating slots across different weeks.
  if (extendedDayOrdering && selectedDay.date) {
    var _filteredOptions = _.filter(reservationOptions, function (_ref11) {
      var startTimeISO = _ref11.startTimeISO;
      if (!startTimeISO) return false;
      var slotDate = moment.tz(startTimeISO, timezone).format('YYYY-MM-DD');
      return slotDate === selectedDay.date;
    });
    return _.uniqBy(_filteredOptions, function (_ref12) {
      var label = _ref12.label;
      return label;
    });
  }

  // Use the effective business day (dayOfWeek) instead of calendar date if extended hours is enabled as that
  // field will be provided on the reservationOptions to compare against
  var selectedDayOfWeek = selectedDay.dayOfWeek;
  var filteredOptions = _.filter(reservationOptions, function (_ref13) {
    var dayOfWeek = _ref13.dayOfWeek;
    return dayOfWeek === selectedDayOfWeek;
  });
  return _.uniqBy(filteredOptions, function (_ref14) {
    var label = _ref14.label;
    return label;
  });
}
export function generateSlotsByZone(slots, zones) {
  return Object.entries(slots).reduce(function (slotTypeAcc, _ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
      slotType = _ref16[0],
      days = _ref16[1];
    slotTypeAcc[slotType] = Object.entries(days).reduce(function (dayAcc, _ref17) {
      var _ref18 = _slicedToArray(_ref17, 2),
        day = _ref18[0],
        daySlots = _ref18[1];
      dayAcc[day] = daySlots.flatMap(function (slot) {
        return zones.map(function (zone) {
          return _objectSpread(_objectSpread({}, slot), {}, {
            deliveryAreaId: zone.name,
            feeInCents: zone.feeInCents,
            minimumInCents: zone.minimumInCents,
            feeType: zone.feeType,
            percentFee: zone.percentFee,
            active: true
          });
        });
      });
      return dayAcc;
    }, {});
    return slotTypeAcc;
  }, {});
}